import { Dropdown } from '@/features/common/Dropdown';
import { useFilterPanelControl } from '@/features/common/FilterPanel/filterPanelControls';
import type { FilterSelectProps } from '@/features/common/FilterPanel/types/FilterSelectProps';

/**
 * One labelled list in a FilterPanel — MUD's select, which is Dropdown: a native <select> cannot
 * be made to match. Which of the panel's lists is open is the panel's to decide, by `name`.
 */
export function FilterSelect({
  name,
  label,
  ariaLabel,
  placeholder,
  options,
  value,
  onChange,
  disabled,
  labelHidden = false,
}: FilterSelectProps) {
  const control = useFilterPanelControl(name);
  return (
    <div className="filter-panel__field">
      {/* A <span>, not a <label>: the control is a listbox button, which a <label> neither names
          nor activates. The word reaches assistive technology through the control's own name,
          which contains it (WCAG 2.5.3). `labelHidden` keeps it for assistive technology and off
          the screen, for a page whose placeholder already says what the list is ("Toate
          raioanele") — shown too, it only repeated it. */}
      <span className={labelHidden ? 'filter-panel__label visually-hidden' : 'filter-panel__label'}>
        {label}
      </span>
      <Dropdown
        size="md"
        ariaLabel={ariaLabel}
        placeholder={placeholder}
        options={options}
        value={value}
        onChange={onChange}
        disabled={disabled}
        {...control}
      />
    </div>
  );
}
